import { render, staticRenderFns } from "./eventNavi.vue?vue&type=template&id=9fc2c500&scoped=true&"
import script from "./eventNavi.vue?vue&type=script&lang=ts&"
export * from "./eventNavi.vue?vue&type=script&lang=ts&"
import style0 from "./eventNavi.vue?vue&type=style&index=0&id=9fc2c500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc2c500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9fc2c500', component.options)
    } else {
      api.reload('9fc2c500', component.options)
    }
    module.hot.accept("./eventNavi.vue?vue&type=template&id=9fc2c500&scoped=true&", function () {
      api.rerender('9fc2c500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/eventNavi.vue"
export default component.exports